import React from 'react';

export const timeFormatHHMM = time => {
  try {
    if (time && !isNaN(new Date(time))) {
      const newTime = new Date(time);
      return `${newTime.getHours() > 9 ? newTime.getHours().toLocaleString() : `0${newTime.getHours()}`}:${newTime.getMinutes() > 9 ? newTime.getMinutes() : `0${newTime.getMinutes()}`}`;
    }
    return null;
  } catch (err) {
    return null;
  }
};

export const timeUTCFormatHHMM = time => {
  try {
    if (time && !isNaN(new Date(time))) {
      const newTime = new Date(time);
      return `${newTime.getUTCHours() > 9 ? newTime.getUTCHours().toLocaleString() : `0${newTime.getUTCHours()}`}:${newTime.getUTCMinutes() > 9 ? newTime.getUTCMinutes() : `0${newTime.getUTCMinutes()}`}`;
    }
    return null;
  } catch (err) {
    return null;
  }
};

export const msToHHMMSS = time => {
  try {
    if (time >= 0) {
      const hours = Math.trunc(((time / 1000) / 60) / 60);
      const minutes = Math.trunc(((time - (hours * 1000 * 60 * 60)) / 1000) / 60);
      const sec = Math.trunc((time - (hours * 1000 * 60 * 60) - (minutes * 1000 * 60)) / 1000);
      return `${hours > 9 ? hours.toLocaleString() : `0${hours}`}:${minutes > 9 ? minutes : `0${minutes}`}:${sec > 9 ? sec : `0${sec}`}`;
    }
    return null;
  } catch (err) {
    return null;
  }
};

export const minutesToHHMMSS = time => {
  try {
    if (time === 0){
      return null;
    }
    if (time >= 0) {
      const newTime = (time * 60);
      const hours = Math.trunc(newTime / 60 / 60);
      const minutes = Math.trunc((newTime - (hours * 60 * 60)) / 60);
      const second = Math.trunc((newTime - (hours * 60 * 60) - (minutes * 60)));
      return `${hours > 9 ? (hours).toLocaleString() : `0${hours}`}:${minutes > 9 ? minutes : `0${minutes}`}:${second > 9 ? second : `0${second}`}`;
    }
    return null;
  } catch (err) {
    return null;
  }
};

export const minutesToHM = time => {
  try {
    if (time >= 0) {
      const hours = Math.trunc(time / 60);
      const minutes = Math.trunc(time - (hours * 60));
      return `${hours ? `${hours.toLocaleString()} ชม.` : ''}${hours && minutes ? ' ' : ''}${minutes ? `${minutes} นาที` : !hours && !minutes ? '0 นาที' : ''}`;
    }
    return null;
  } catch (err) {
    return null;
  }
};

export const msToHHMM = time => {
  try {
    if (time >= 0) {
      const hours = Math.trunc(((time / 1000) / 60) / 60);
      const minutes = Math.trunc(((time - (hours * 1000 * 60 * 60)) / 1000) / 60);
      return `${hours ? `${hours.toLocaleString()} ชม.` : ''}${hours && minutes ? ' ' : ''}${minutes ? `${minutes} นาที` : !hours && !minutes ? '0 นาที' : ''}`;
    }
    return null;
  } catch (err) {
    return null;
  }
};

export const msToHM = time => {
  try {
    if (time >= 0) {
      const hours = Math.trunc(((time / 1000) / 60) / 60);
      const minutes = Math.trunc(((time - (hours * 1000 * 60 * 60)) / 1000) / 60);
      return <><span className="bold mr">{hours >= 0 ? hours.toLocaleString() : 0}</span> ชม. <span className="bold mr">{minutes >= 0 ? minutes : 0}</span> นาที</>;
    }
    return null;
  } catch (err) {
    return null;
  }
};

export const minutesToHHMM = time => {
  try {
    if (time >= 0) {
      const hours = Math.trunc(time / 60);
      const minutes = Math.trunc(time - (hours * 60));
      return `${hours > 9 ? hours.toLocaleString() : `0${hours}`}:${minutes > 9 ? minutes : `0${minutes}`}`;
    }
    return null;
  } catch (err) {
    return null;
  }
};

export const minutesToHr = time => {
  try {
    if (time >= 0) {
      const hours = Math.trunc(time / 60);
      const minutes = Math.trunc(time - (hours * 60));
      return `${hours >= 0 ? hours.toLocaleString() : 0}${minutes > 9 ? `.${minutes}` : minutes > 0 ? `.0${minutes}` : ''}`;
    }
    return null;
  } catch (err) {
    return null;
  }
};

export const minToHr = (time, hideMin) => {
  try {
    if (time >= 0) {
      const hours = Math.trunc(time / 60);
      const minutes = Math.trunc(time - (hours * 60));
      return `${hours >= 0 ? hours.toLocaleString() : 0}${hideMin ? '' : `.${(minutes >= 0 ? minutes : 0)}`}`;
    }
    return null;
  } catch (err) {
    return null;
  }
};

export const minToHM = time => {
  try {
    if (time >= 0) {
      const hours = Math.trunc(time / 60);
      const minutes = Math.trunc(time - (hours * 60));

      return `${hours > 0 ? hours.toLocaleString() : ''}${hours && minutes ? ' ' : ''}${(minutes > 0 ? minutes : hours === 0 && minutes === 0 ? 0 : '')} ${hours ? 'ชั่วโมง' : 'นาที'}`;
    }

    return null;
  } catch (err) {
    return null;
  }
};

export const timestampToHr = time => {
  try {
    if (time >= 0) {
      const newTine = Math.trunc(time / 1000 / 60);
      const hours = Math.trunc(newTine / 60);
      const minutes = Math.trunc(newTine - (hours * 60));
      return `${hours >= 0 ? hours.toLocaleString() : 0}.${minutes >= 0 ? minutes : 0}`;
    }
    return null;
  } catch (err) {
    return null;
  }
};

export const minutesToHours = min => {
  try {
    if (min >= 0) {
      return Math.trunc(min / 60);
    }
    return null;
  } catch (err) {
    return null;
  }
};

export const getTimeHHMMSS = time => {
  try {
    if (time) {
      const date = new Date(time);
      return `${date.getHours() > 9 ? date.getHours() : `0${date.getHours()}`}:${date.getMinutes() > 9 ? date.getMinutes() : `0${date.getMinutes()}`}:${date.getSeconds() > 9 ? date.getSeconds() : `0${date.getSeconds()}`}`;
    }
    return null;
  } catch (error) {
    return null;
  }
};

export const getTimeHHMM = time => {
  try {
    if (time) {
      const date = new Date(time);
      return `${date.getHours() > 9 ? date.getHours() : `0${date.getHours()}`}:${date.getMinutes() > 9 ? date.getMinutes() : `0${date.getMinutes()}`}`;
    }
    return null;
  } catch (error) {
    return null;
  }
};

export const minutesToMillisec = min => {
  try {
    return min ? (min * 60000) : 0;
  } catch (error) {
    return null;
  }
};
